export default __webpack_public_path__ + "static/media/DataReleased.98adb70f.png";